import {BaseModule} from "./base/base";

export class FormFixer extends BaseModule {
    constructor() {
        super();
        this.setClass();

        if (document.body.classList.contains('page-template-template-form')) {
            this.moveMessage();
        }
    }

    setClass() {
        const form = document.querySelector( '.nf-form-cont' );

        if ( form ) {
            setTimeout( () => {
                const rows = form.querySelectorAll( '.nf-row' );
                const last = rows.length;

                const upload = form.querySelector( '.nf-row:last-child .file_upload-wrap' );
                const submit = form.querySelector( `.nf-row:nth-child(${last-1}) .submit-wrap` );

                if ( upload && submit ) {
                    form.classList.add( 'modify-upload' );
                    // upload.parentNode.insertBefore( submit, upload.nextSibling );
                }
            }, 300)
        }
    }

    moveMessage() {
        setTimeout(() => {
            const responseMsg = document.querySelector('.nf-response-msg');
            const formLayout = document.querySelector('.nf-form-layout');

            if (responseMsg && formLayout) {
                formLayout.insertAdjacentElement('afterend', responseMsg);
            }
        }, 300)
    }

}
